import React from "react";
import Loadable from "../../react-loadable";
const TransferList = Loadable({
  loader: () => import("./list"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
export default TransferList;



// WEBPACK FOOTER //
// ./_antd1.11.2/transfer/ListAsync.jsx